import Vue from 'vue'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import App from './AppPhase5.vue'
import router from './router'
import FirstBookSemanticsCopyPlugin from './plugins/firstBookSemanticsCopy'
import DashboardDeepLinkReceiversPlugin from './plugins/dashboardDeepLinkReceivers'

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(FirstBookSemanticsCopyPlugin)
Vue.use(DashboardDeepLinkReceiversPlugin)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')